/*
 * @Author: zhangwangwang
 * @Date: 2021-07-20 11:26:47
 * @Last Modified by: zhangwangwang
 * @Last Modified time: 2024-09-19 17:41:31
 */

module.exports = {
  // API: `/dtdtest`,
  API: `/dtd`,
  // API: `/api`,
};
